var React = require('react');

function EncompassSectionBg (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":"0.0845063"},[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M199.54 395.809C108.986 386.467 38.1385 309.731 38.1385 216.766C38.1385 123.801 108.986 47.0655 199.54 37.7234V0.35498C88.2817 9.80572 0.900391 103.053 0.900391 216.766C0.900391 330.479 88.2817 423.727 199.54 433.177V395.809Z","fill":"#00B2A9","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M236.777 0.35498V37.7234C327.331 47.0655 398.179 123.801 398.179 216.766C398.179 309.731 327.331 386.467 236.777 395.809V433.177C348.035 423.727 435.417 330.479 435.417 216.766C435.417 103.053 348.035 9.80572 236.777 0.35498Z","fill":"#00B2A9","key":1})]));
}

EncompassSectionBg.defaultProps = {"width":"436","height":"434","viewBox":"0 0 436 434","fill":"none"};

module.exports = EncompassSectionBg;

EncompassSectionBg.default = EncompassSectionBg;
